import { Aplazame, Card, LinkagePay, Openpay, PCI, Tpv } from '../components';

const COMPONENTS = {
  1: Card,
  2: PCI,
  3: Tpv,
  4: Aplazame,
  5: Openpay,
  6: LinkagePay,
};

export { COMPONENTS };
